import React, { useEffect } from 'react';
import { Button, Select, Drawer, Form, Input, message } from 'antd';
import {
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { requiredRule } from 'utils/forms/validationRules';
import { PermissionsService } from 'services/PermissionsService';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

function PermissionsForm({
  isActive,
  onClose,
  onSuccess,
  initialValues,
  modules,
}) {
  const [form] = Form.useForm();
  const isEditing = initialValues !== null;

  useEffect(() => {
    if (initialValues) {
      const { name, slug, module_id, component } = initialValues;

      form.setFieldsValue({
        name,
        slug,
        module_id,
        function: initialValues.function,
        component,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    if (isEditing) {
      handleUpdate(values, initialValues.id);
    } else {
      handleCreate(values);
    }
  };

  const handleCreate = async (data) => {
    const hide = message.loading(REQUEST_LOADING);
    const isCreated = await PermissionsService.createPermission(data);

    if (isCreated) {
      hide();
      message.success(SUCCESS_CREATE);
      handleConfirm();
    }
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);
    const isUpdated = await PermissionsService.editPermission(data, id);

    if (isUpdated) {
      hide();
      message.success(SUCCESS_UPDATE);
      handleConfirm();
    }
  };

  const handleConfirm = () => {
    form.resetFields();
    onClose();
    onSuccess();
  };

  return (
    <Drawer
      title={isEditing ? 'Редактирование доступа' : 'Создание доступа'}
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        initialValues={{ active: true }}
        labelAlign="right"
      >
        <Form.Item name="name" label="Наименование" rules={[requiredRule]}>
          <Input placeholder="Введите наименование" allowClear />
        </Form.Item>

        <Form.Item name="slug" label="Slug" rules={[requiredRule]}>
          <Input placeholder="Введите slug" allowClear />
        </Form.Item>

        <Form.Item name="module_id" label="Модуль">
          <Select
            allowClear
            placeholder="Выбрать модуль"
            showSearch
            optionFilterProp="children"
          >
            {modules?.map(({ id, name }) => (
              <Select.Option key={id} value={id}>
                {name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {isEditing && (
          <>
            <Form.Item name="function" label="Функция" rules={[requiredRule]}>
              <Input placeholder="Введите function" />
            </Form.Item>

            <Form.Item
              name="component"
              label="Компонент"
              rules={[requiredRule]}
            >
              <Input placeholder="Введите component" />
            </Form.Item>
          </>
        )}

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { PermissionsForm };
